import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./RoutingMenu.scss";
import dashboardIcon from "../../images/dashboard.svg";
import admin from "../../images/admin.svg";
import crmIcon from "../../images/crm.svg";
import reportingIcon from "../../images/reporting.svg";
import loansIcon from "../../images/loans.svg";
import complianceIcon from "../../images/compliance.svg";
import batchservicesIcon from "../../images/batchservices.svg";
import settingIcon from "../../images/settings.svg";
import logoutIcon from "../../images/logout.svg";
import treasuryIcon from "../../images/treasuryIcon.svg";
import card from "../../images/card.svg";
import settlementIcon from "../../images/settlement.svg";
import billpaymentIcon from "../../images/billpayment.svg";
import bnplIcon from "../../images/bnpl.svg";
import marketplaceIcon from "../../images/marketplace.svg";
import posIcon from "../../images/pos.svg";
import feeIcon from "../../images/fee.svg";
import workflowsIcon from "../../images/workflows.svg";
import atmIcon from "../../images/atm.svg";
import mobileIcon from "../../images/mobileIcon.svg";
import agentIcon from "../../images/agent.svg";
import transferIcon from "../../images/transfers.svg";
import { setLoggedOutUser } from "../../store/redux/login";
import { setTitle } from "../../store/redux/selectedScreen";
import { Box, Drawer, IconButton } from '@mui/material';
import ExpandedRoutingMenu from "./ExpandedRoutingMenu";
import { KeyboardArrowRight } from "@mui/icons-material";
import { setSidebarOpen, toggleSidebar } from "../../store/redux/uiSlice";
import { getUserSidebarPermissions } from "../../util/API/customers";

const menuItems = [
  {
    id: "dashboard",
    text: "Dashboard",
    icon: dashboardIcon,
    activeIcon: dashboardIcon,
    appid: "400090001",
  },
  { id: "crm", 
    text: "CRM", 
    icon: crmIcon, 
    activeIcon: crmIcon, 
    appid: "400010001" 
  },
  {
    id: "transfers",
    text: "Transfers",
    icon: transferIcon,
    activeIcon: transferIcon,
    appid: "400120001",
  },
  {
    id: "reporting",
    text: "Reporting",
    icon: reportingIcon,
    activeIcon: reportingIcon,
    appid: "400080001",
  },
  {
    id: "userreporting",
    text: "Onboarding Report",
    icon: reportingIcon,
    activeIcon: reportingIcon,
    appid: "400160002",
  },
  {
    id: "portfolio",
    text: "Portfolio",
    icon: reportingIcon,
    activeIcon: reportingIcon,
    appid: "400160006",
  },
  {
    id: "ofacreporting",
    text: "OFAC Report",
    icon: reportingIcon,
    activeIcon: reportingIcon,
    appid: "400160003",
  },
  {
    id: "cofi",
    text: "CoFi",
    icon: reportingIcon,
    activeIcon: reportingIcon,
    appid: "400160005",
  },
  {
    id: "compliance",
    text: "TX Monitoring",
    icon: complianceIcon,
    activeIcon: complianceIcon,
    appid: "",
  },
  {
    id: "batch",
    text: "Batch Services",
    icon: batchservicesIcon,
    activeIcon: batchservicesIcon,
    appid: "400020001",
  },
  {
    id: "payrollbatch",
    text: "Payroll Batch Services",
    icon: batchservicesIcon,
    activeIcon: batchservicesIcon,
    appid: "400020002",
  },
  {
    id: "treasury",
    text: "Treasury",
    icon: treasuryIcon,
    activeIcon: treasuryIcon,
    appid: "400040001",
  },
  {
    id: "accounting",
    text: "Accounting",
    icon: reportingIcon,
    activeIcon: reportingIcon,
    appid: "",
    // appid: "400050001",
  },
  {
    id: "agents",
    text: "Agents",
    icon: agentIcon,
    activeIcon: agentIcon,
    appid: "400130001",
  },
  {
    id: "loans",
    text: "Loans",
    icon: loansIcon,
    activeIcon: loansIcon,
    appid: "400140001",
  },
  {
    id: "devicemanagement",
    text: "Device Management",
    icon: mobileIcon,
    activeIcon: mobileIcon,
    appid: "",
  },
  {
    id: "operators",
    text: "Operators",
    icon: crmIcon,
    activeIcon: crmIcon,
    appid: "400100001",
  },

  {
    id: "cardservices",
    text: "Card Services",
    icon: card,
    activeIcon: card,
    appid: "400150001",
  },
  {
    id: "bnpl",
    text: "BNPL",
    icon: bnplIcon,
    activeIcon: bnplIcon,
    appid: "",
  },

  {
    id: "settlement",
    text: "Settlement",
    icon: settlementIcon,
    activeIcon: settlementIcon,
    appid: "",
  },
  {
    id: "billpayment",
    text: "Bill Payment",
    icon: billpaymentIcon,
    activeIcon: billpaymentIcon,
    appid: "",
  },
  {
    id: "atmservices",
    text: "ATM Services",
    icon: atmIcon,
    activeIcon: atmIcon,
    appid: "400160001",
  },
  {
    id: "posservice",
    text: "POS Service",
    icon: posIcon,
    activeIcon: posIcon,
    appid: "",
  },
  {
    id: "marketplace",
    text: "Marketplace",
    icon: marketplaceIcon,
    activeIcon: marketplaceIcon,
    appid: "",
  },

  {
    id: "feemodule",
    text: "Fee Module",
    icon: feeIcon,
    activeIcon: feeIcon,
    appid: "",
  },
  {
    id: "workflows",
    text: "Workflows",
    icon: workflowsIcon,
    activeIcon: workflowsIcon,
    appid: "",
  },
  {
    id: "settings",
    text: "Settings",
    icon: settingIcon,
    activeIcon: settingIcon,
    appid: "400070001",
  },
  {
    id: "admin",
    text: "Admin",
    icon: admin,
    activeIcon: admin,
    appid: "400110001",
  },
  {
  id: "payrolladmin",
  text: "Payroll Admin",
  icon: admin,                    // Reusing the same admin icon
  activeIcon: admin,              // Same for active state
  appid: "400060001",             // SAME AS REGULAR ADMIN → same access level
},

  {
    id: "payrollreports",
    text: "Payroll Reports",
    icon: reportingIcon,
    activeIcon: reportingIcon,
    appid: "400012001",  
  },
    {
    id: "superadmin-payroll-reports",
    text: "NCS Payroll Reports",
    icon: reportingIcon,
    activeIcon: reportingIcon,
    appid: "400011001",
    },

  
  // {
  //   id: "help",
  //   text: "Help Centre",
  //   icon: helpcenterIcon,
  //   activeIcon: helpcenterIconActive,
  //   subMenu: [],
  // },
  // {
  //   id: "collaborationengine",
  //   text: "Collaboration Engine",
  //   icon: complianceIcon,
  //   activeIcon: complianceIconActive,
  // },
  {
    id: "",
    text: "Logout",
    icon: logoutIcon,
    activeIcon: logoutIcon,
    appid: "0",
  },
];

function RoutingMenu({ searchInput, setSearchInput, devEnvironment }) {
  const [activeMenuItem, setActiveMenuItem] = useState("CRM");
  const [open, setOpen] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [matchingItems, setMatchingItems] = useState([]);
  const location = useLocation(); // Add this line to track route changes
  const [allowedAppIds, setAllowedAppIds] = useState([]);
  const [userRole, setUserRole] = useState(""); // For portfolio module sidebar dynamic name

  
  let isAdmin = sessionStorage.getItem("isAdmin");
  let isOperator = sessionStorage.getItem("isOperator");
  let isSuperAdmin = sessionStorage.getItem("isSuperAdmin");
  let isAssociateAgent = sessionStorage.getItem("isAssociateAgent");
  let isSuperAgent = sessionStorage.getItem("isSuperAgent");
  let securityRoleId = sessionStorage.getItem("userSecurityRoleId");
  let agent = JSON.parse(sessionStorage.getItem("user"))?.payload?.body;

  let configVariables = useSelector((state) => state.config.baseConfig);
  let userSecurityRoles = JSON.parse(sessionStorage.getItem("user"))?.payload?.body?.Securityuserrole;
  const sidebarOpen = useSelector((state) => state.ui.sidebarOpen);

  useEffect(() => {
    // 1. Normalize user roles to an array
    const userRoles = Array.isArray(userSecurityRoles)
        ? userSecurityRoles
        : [userSecurityRoles];

    // 2. Helper function to parse comma-separated IDs from config
    const parseConfigIds = (ids) => 
        ids?.toString().split(',').map(id => Number(id.trim())) || [];

    const adminRolesArray = parseConfigIds(configVariables?.portfolioAdminRoleIds);
    const delegateRolesArray = parseConfigIds(configVariables?.delegateRoleIds);
    // Note: investorRoleIds exists in your config but usually acts as the default fallback

    // 3. Check membership
    const isAdmin = userRoles.some(role =>
        adminRolesArray.includes(Number(role?.roleid))
    );

    const isDelegate = userRoles.some(role =>
        delegateRolesArray.includes(Number(role?.roleid))
    );

    // 4. Set role based on priority (Admin > Delegate > Investor)
    if (isAdmin) {
      // console.log("Role- Admin");
      setUserRole("admin");
    } else if (isDelegate) {
      // console.log("Role- Delegate");
      setUserRole("delegate");
    } else {
      // console.log("Role- Investor");
      setUserRole("investor");
    }

  }, [userSecurityRoles, configVariables]);
  // useEffect(() => {
  //   // Ensure userSecurityRoles is always an array
  //   const userRoles = Array.isArray(userSecurityRoles)
  //       ? userSecurityRoles
  //       : [userSecurityRoles];

  //   // Convert comma-separated strings into arrays
  //   const investorRolesArray = configVariables?.investorRoleIds
  //       ?.toString()
  //       .split(',')
  //       .map(id => Number(id.trim()));

  //   const adminRolesArray = configVariables?.portfolioAdminRoleIds
  //       ?.toString()
  //       .split(',')
  //       .map(id => Number(id.trim()));

  //   // Check if any user role matches admin role IDs
  //   const isAdmin = userRoles.some(role =>
  //       adminRolesArray?.includes(Number(role?.roleid))
  //   );
    
  //   // console.log("userRoles-------------",userRoles);
  //   // console.log("adminRolesArray-------------",adminRolesArray);
  //   // console.log("isAdmin-------------",isAdmin);
    
  //   if (isAdmin) {
  //       setUserRole("admin");
  //   } else {
  //       setUserRole("investor");
  //   }

  // }, [userSecurityRoles, configVariables]); 

  useEffect(()=> {
    getUserMenuPermissions();
  }, [])

  useEffect(() => {
    if (searchInput) {
      const matched = menuItems.filter(item =>
        item.text.toLowerCase().includes(searchInput.toLowerCase())
      );
      setMatchingItems(matched);
    } else {
      setMatchingItems([]); // Clear matches when the input is cleared
    }
  }, [searchInput]);

  const getUserMenuPermissions = async() => {
    let response = await getUserSidebarPermissions(agent['User'].id);
    if (response?.data?.header?.callStatus === "1") {
      const record = response?.data?.body?.record;
      const recordsArray = Array.isArray(record) ? record : [record];
      const allowed = recordsArray
        .map(item => item?.Vappsrole?.appid)
        .filter(Boolean); // filter out undefined/null
        console.log(allowed)
      setAllowedAppIds(allowed);
    }
  }


  // const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const menuRef = useRef();

  const [isMenuExpanded, setIsMenuExpanded] = useState(false);

  const handleMenuExpansion = () => {
    setIsMenuExpanded((prev) => !prev); // Toggle menu expansion state
    setOpen(!open);
    
    dispatch(toggleSidebar());
  };

  // Function to preload menu item images to improve performance

  const preloadImages = () => {
    menuItems.forEach((item) => {
      const img = new Image();
      img.src = item.icon;
      const imgActive = new Image();
      imgActive.src = item.activeIcon;
    });
  };

  const checkIfAtBottom = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const clientHeight = document.documentElement.clientHeight;
    const scrollHeight = document.documentElement.scrollHeight;
    return scrollTop + clientHeight >= scrollHeight - 10;
  };
  

  useEffect(() => {
    preloadImages();
  }, []);

  useEffect(() => {
    const atBottom = checkIfAtBottom();
    setIsAtBottom(atBottom);

    // Attach scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location])

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const clientHeight = document.documentElement.clientHeight;
    const scrollHeight = document.documentElement.scrollHeight;

    // Check if scrolled to the end of the page
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setIsAtBottom(true);
    } else {
      setIsAtBottom(false);
    }
  };

  //This is an example of how we can use config to hide or show menu items
  // const availableMenuItems = menuItems.filter((item) => config[item.id]);

  // const filteredMenuItems = searchInput
  //   ? availableMenuItems.filter((item) =>
  //       item.text.toLowerCase().includes(searchInput.toLowerCase())
  //     )
  //   : availableMenuItems;

  // Handler for menu item click events
  function handleMenuItemClick(menuItem) {
    //This checks if the menu item is an empty string. If it is, then it would logout
    if (menuItem === "") {
      sessionStorage.clear();
      // setSidebarOpen(false);
      if(sidebarOpen) {
        dispatch(toggleSidebar());
      }
      dispatch(setLoggedOutUser());
      navigate("/");
      return;
    }

    const menuItemData = menuItems.find((item) => item.id === menuItem);

    if (isMenuItemDisabled(menuItem)) {
      return;
    }

    dispatch(setTitle(menuItemData.text));
    setActiveMenuItem(menuItem);
    setSearchInput("");
    navigate(`/${menuItem}`);
  }

  const disabledMenuItems = [
    "collaborationengine",
    "Settlement",
    isAdmin === 'false' && "cardservices",
    "bnpl",
    "settlement",
    "billpayment",
    "posservice",
    "help",
    "marketplace",
    "feemodule",
    "workflows",
    "compliance",
    (isSuperAdmin === "false") && "batch",
    "accounting",
    // isAdmin === "false" && "agents",
    !devEnvironment && "agents",
    "devicemanagement",
    isAdmin === 'false' && "atmservices",
    (isOperator === 'true' || isAdmin === 'true' || isAssociateAgent === 'true' || isSuperAgent === 'true') && "operators",
    isSuperAdmin === 'false' && "admin",
    !devEnvironment && "loans",
    !devEnvironment && "dashboard",
    !devEnvironment && "treasury",
    isAssociateAgent === 'true' && "transfers", 
    isAssociateAgent === 'true' && "reporting", 
    isAdmin === 'false' && "settings",
  ];

  const systemMenuItems = [
    "settings",
    isAdmin === "true" && "admin",
    ""
  ]

  function isMenuItemDisabled(menuItemId) {
    return disabledMenuItems.includes(menuItemId);
  }

  // const filteredMenuItems = menuItems.filter(
  //   (item) => !isMenuItemDisabled(item.id)
  // );

  let filteredMenuItems;

  // if (securityRoleId == '844' || securityRoleId == '843' || securityRoleId == '707') {
  //   // Only allow "reporting" if isAccClerk is true
  //   filteredMenuItems = menuItems.filter(item => item.id === "reporting" || item.id === "");
  // } else {
  //   // Normal filtering logic
  //   filteredMenuItems = menuItems.filter(
  //     (item) => !isMenuItemDisabled(item.id)
  //   );
  // }

  const updatedMenuItems = menuItems.map(item => {
    if (item?.id === "portfolio" && userRole == "admin") {
      return { ...item, text: "Holt Xchange Investments" }; // create new object
    } else if (item?.id === "portfolio" && (userRole == "investor" || userRole == "delegate")) {
      return { ...item, text: "My Investments" }; // create new object
    }
    return item;
  });
  
  filteredMenuItems = updatedMenuItems.filter(item => {
    return allowedAppIds.includes(item.appid) || item.id === "";
  });

  // Computed list of menu items based on the search input
  const finalMenuItems = filteredMenuItems;
// console.log("finalMenuItems==============",finalMenuItems);
  return (
      <Drawer
        variant="permanent"
        sx={{
          "& .MuiDrawer-paper": {
            width: open ? '343px' : '124px',
            // width: "124px",
            height: "calc(100vh - 79px - 52px)", 
            position: "fixed",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            // paddingTop: "20px",
            top: "79px",
            bottom: "53px",
            borderRight: "0.5px solid #E6E3E3", 
            overflow: "visible",
            zIndex: 999,
            borderTop: "0.5px solid #E6E3E3",
            transition: (theme) =>
              theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.standard,
              }),
          },
        }}
      >
        {!open ? 
        (
        <>
          <IconButton
            onClick={handleMenuExpansion}
            sx={{
              position: "absolute",
              right: "-36px", 
              top: "0px", 
              backgroundColor: "#ffffff",
              borderTopRightRadius: "5px", 
              borderBottomRightRadius: "5px", 
              borderTopLeftRadius: "0px", 
              borderBottomLeftRadius: "0px", 
              borderRight: "0.5px solid #E6E3E3", 
              borderBottom: "0.5px solid #E6E3E3",
              width: "36px", 
              height: "36px", 
              borderTop: "0.5px solid #E6E3E3",
              transition: 'transform 0.3s ease',
              "&:hover": {
                backgroundColor: "#fff",
              },
              cursor: "none",
            }}
          >
            <KeyboardArrowRight
              sx={{
                transition: "transform 0.3s ease",
                color: "#9E9E9E",
                border: "1px solid #B0B0B0", 
                borderRadius: "5px",
                width: "20px",
                height: "20px",
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                },
              }}
            />
          </IconButton>

      {/* Searched Items */}
      {matchingItems.length > 0 && (
        <Box 
          sx={{ 
            width: "90%", 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center",
            backgroundColor: "#F5F5F5", // Light grey background for the search result box
            padding: "10px",
            borderRadius: "10px",
            marginBottom: "20px",
            overflowY: "auto",
            flexGrow: 1, 
            '&::-webkit-scrollbar': {
              width: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#cccccc', // Customize scrollbar thumb if needed
            },
            '@media (max-height: 900px)': {
              height: matchingItems.length > 1 ? '40%' : "16%",  
            },
          }}
        >
          {matchingItems.map((data, i) => (
            <Box key={i} sx={{ width: "100%" }}>
              <Link
                to={isMenuItemDisabled(data.id) ? "#" : `/${data.id}`} // Disable routing for disabled items
                style={{ textDecoration: "none", width: "100%" }}
              >
                <Box
                  onClick={() => handleMenuItemClick(data.id)}
                  sx={{
                    width: "100%",
                    padding: "5px 0",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: isMenuItemDisabled(data.id) ? "not-allowed" : "pointer", // Disable pointer cursor for disabled items
                    transition: "background-color 0.3s",
                    borderRadius: "8px",
                    backgroundColor: activeMenuItem === data.id ? "#f5f5f5" : "", 
                    opacity: isMenuItemDisabled(data.id) ? 0.5 : 1, // Lower opacity for disabled items
                    "& img": {
                      filter: activeMenuItem === data.id ?  "brightness(0) saturate(100%) invert(26%) sepia(72%) saturate(5000%) hue-rotate(240deg) brightness(95%) contrast(85%)" : "", // Hover effect for enabled items
                    },
                    "&:hover": isMenuItemDisabled(data.id) ? {} : { // Disable hover for disabled items
                      backgroundColor: "#e9eef6", 
                      color: "#7a51e5", // Change text color on hover
                      "& .menu-item-text": {
                        color: "#555", // Hover effect for enabled items
                      },
                    },
                  }}
                >
                  <img
                    src={data.icon}
                    alt={data.text}
                    style={{ 
                      height: "20px", 
                      width: "20px", 
                      marginBottom: "8px",
                      filter: "brightness(0) saturate(100%) invert(16%) sepia(4%) saturate(199%) hue-rotate(169deg) brightness(94%) contrast(88%)"
                    }}
                    loading="lazy"
                  />
                  <Box 
                  className="menu-item-text" // Use this class to target the text for hover
                  sx={{ 
                    textAlign: "center", 
                    color: "#212529", // Default text color
                    fontSize: "14px", 
                    fontWeight: "500", 
                    transition: "color 0.3s ease", // Smooth transition for the color change
                  }}
                >
                  {data.text}
                </Box>
                </Box>
              </Link>
            </Box>
          ))}
        </Box>
      )}

      {/* Menu Items */}
      <Box 
        sx={{ 
          width: "100%", 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center",
          // flexGrow: 1, 
          overflowY: "auto", 
        }}
      >
        {finalMenuItems.map((data, i) => (
          <Box key={i} sx={{ width: "100%" }}>
            <Link
              to={matchingItems.length === 0 ? `/${data.id}` : "#"} // Only make other items clickable if no search
              style={{
                textDecoration: "none",
                color: matchingItems.length === 0 ? "#555" : "#9E9E9E", // Disable color when searching
                pointerEvents: matchingItems.length === 0 ? "auto" : "none", // Disable clicks if searching
                width: "100%",
              }}
            >
              <Box
                onClick={() => handleMenuItemClick(data.id)}
                sx={{
                  width: "100%",
                  padding: "10px 2px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: matchingItems.length === 0 ? "pointer" : "default", // Only show pointer if not searching
                  transition: "background-color 0.3s",
                  // borderRadius: "8px",
                  backgroundColor: activeMenuItem === data.id ? "#f5f5f5" : "", 
                  "&:hover": { 
                    backgroundColor: "#e9eef6", 
                    color: "#555", // Change text color on hover
                    "& img": {
                      // filter: "brightness(0) saturate(100%) invert(26%) sepia(72%) saturate(5000%) hue-rotate(240deg) brightness(95%) contrast(85%)", // Closer match to purple
                    },
                    "& .menu-item-text": { // Ensure the text becomes purple on hover
                      color: "#555",
                      // color: "#5523d2",
                      
                    },
                  },
                }}
              >
                <img
                  src={activeMenuItem === data.id ? data.activeIcon : data.icon}
                  alt={data.text}
                  style={{ 
                    height: "20px", 
                    width: "20px", 
                    marginBottom: "2px", 
                    filter: "brightness(0) saturate(100%) invert(16%) sepia(4%) saturate(199%) hue-rotate(169deg) brightness(94%) contrast(88%)"
                  }}
                  loading="lazy"
                />
                <Box 
                  className="menu-item-text" // Use this class to target the text for hover
                  sx={{ 
                    textAlign: "center", 
                    color: "#212529", // Default text color
                    fontSize: "14px", 
                    fontWeight: "500", 
                    transition: "color 0.3s ease", // Smooth transition for the color change
                  }}
                >
                  {data.text}
                </Box>
              </Box>
            </Link>
            {i < finalMenuItems.length - 1 && (
              <Box sx={{ width: "100%", borderBottom: "0.5px solid #ddd", margin: "0px auto" }} />
            )}
          </Box>
        ))}
      </Box>
      </>
      ) : 
      <>
      <ExpandedRoutingMenu 
        open={open}
        handleMenu={handleMenuExpansion} 
        menuItems={menuItems}
        finalMenuItems={finalMenuItems.filter(item => !systemMenuItems.includes(item.id))}
        disabledMenuItems={disabledMenuItems}
        isMenuItemDisabled={isMenuItemDisabled}
        systemMenuItems={systemMenuItems}
        handleMenuItemClick={handleMenuItemClick}
        activeMenuItem={activeMenuItem}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        matchingItems={matchingItems}
        isAtBottom={isAtBottom}
        allowedAppIds={allowedAppIds}
      />
      </> }
      </Drawer>
  );  
}

export default RoutingMenu;